<template>
  <section class="datos-personales" v-if="true">
    <!--<button><i class="fa fa-user"></i></button>-->
    <ul class="nav d-flex flex-row justify-content-around align-items-center py-2 w-100 mx-auto my-0" id="myTab"
        role="tablist">
      <li
        class="nav-item px-2 grow-1 d-flex flex-colum justify-content-center align-items-center pt-4 h-50 w-75"
        :class="{ 'border border-1 shadow not-user':!autenticado }"
        role="presentation">
        <div class="d-flex flex-column justify-content-center align-items-center">
        <div class="mb-2" v-if="!autenticado">
          {{ idioma.intro }}
        </div>
        <CustomerLogin class="text-center my-3" :idioma="idioma.login" :isUser="autenticado"
                       @loginSuccess="logueado"
                       @getOut="salir"/>
        <p class="mt-3 text-center" style="line-height: 5px" v-if="!autenticado">
          {{ idioma.mensaje[0] }}
        </p>
        <p class="text-center" style="line-height: 5px" v-if="!autenticado">
          {{ idioma.mensaje[1] }}
        </p>
        <div class="mt-5" v-if="!autenticado">
          <svg width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#05bdbd" fill="none"
               stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"/>
            <path d="M10 10c-.5 -1 -2.5 -1 -3 0"/>
            <path d="M17 10c-.5 -1 -2.5 -1 -3 0"/>
            <path d="M14.5 15a3.5 3.5 0 0 1 -5 0"/>
          </svg>
        </div>
        <p class="mt-4 mb-0 text-center" v-if="!autenticado">
          {{ idioma.opcion }}
        </p>
        <p class="text-center p-0 m-0" style="line-height: 5px" v-if="!autenticado">
          <button class="bg-transparent text-info p-0 mb-3" id="profile-tab" data-toggle="tab" data-target="#profile"
                  type="button"
                  role="tab"
                  aria-controls="profile" aria-selected="false">
            {{ idioma.continuar }}
          </button>
        </p>
        <p>

        </p>
        </div>
      </li>
    </ul>
    <div class="tab-content d-flex flex-row justify-content-center align-items-center" id="myTabContent">
      <div class="tab-pane fade my-5 d-flex flex-column"
           :class="{ 'active show': !autenticado}"
           id="home" role="tabpanel"
           aria-labelledby="home-tab">
      </div>
      <div class="tab-pane fadealign-self-start"
           :class="{ 'active show': autenticado}"
           id="profile" role="tabpanel" aria-labelledby="profile-tab">
        <!-- Datos personales del cliente -->
        <article class="datos-personales col-12 mt-4">
          <div class="form-row">

            <div class="form-group col-12 col-md-4">
              <label for="email" v-text="idioma.correoe" class="requerido"></label><br>
              <input type="text" id="email" name="email" v-model="cliente.email" ref="email"
                     @blur="validate('email',[{'lon':3}, {'mail':true}])"
                     maxlength="150"
                     :class="[{'error': validado.email === false, 'success': validado.email}]"><br>
              <small :class="[{ 'errorMsg': validado.email === false, 'valid': validado.email !== false}]"
                     v-text="idioma.errores.correo"></small>
            </div>

            <div class="form-group col-12 col-md-4">
              <label for="confirmar" v-text="idioma.confirmar" class="requerido"></label><br>
              <input type="text" id="confirmar" name="confirmar" v-model="cliente.confirmar" ref="confirmar"
                     @blur="confirmEmail"
                     maxlength="150"
                     :class="[{'error': validado.confirmar === false, 'success': validado.confirmar}]"><br>
              <small :class="[{ 'errorMsg': validado.confirmar === false, 'valid': validado.confirmar !== false}]"
                     v-text="idioma.errores.confirmarCorreo"></small>
            </div>

            <div class="form-group col-12 col-md-4">
              <label for="tfno" v-text="idioma.tfno" class="requerido"></label><br>
              <input type="text" id="tfno" name="tfno" v-model="cliente.phone" ref="phone"
                     @blur="validate('phone',[{'lon':9}])"
                     minlength="9"
                     maxlength="9"
                     :class="[{'error': validado.phone === false, 'success': validado.phone}]"><br>
              <small :class="[{ 'errorMsg': validado.phone === false, 'valid': validado.phone !== false}]"
                     v-text="idioma.errores.tfno"></small>
            </div>

            <div class="form-group col-12 col-md-4">
              <label for="name" v-text="idioma.nombre" class="requerido"></label><br>
              <input type="text" id="name" name="name" v-model="cliente.name" ref="name"
                     maxlength="150"
                     @blur="validate('name',[{'lon':3}])"
                     :class="[{'error': validado.name === false, 'success': validado.name}]"><br>
              <small :class="[{ 'errorMsg': validado.name === false, 'valid': validado.name !== false}]"
                     v-text="idioma.errores.nombre">
              </small>
            </div>

            <div class="form-group col-12 col-md-4">
              <label for="apellidos" v-text="idioma.apellidos" class="requerido"></label><br>
              <input type="text" id="apellidos" name="apellidos" v-model="cliente.surname" ref="surname"
                     maxlength="150"
                     @blur="validate('surname',[{'lon':3}])"
                     :class="[{'error': validado.surname === false, 'success': validado.surname}]"><br>
              <small :class="[{ 'errorMsg': validado.surname === false, 'valid': validado.surname !== false}]"
                     v-text="idioma.errores.apellidos">
              </small>
            </div>

            <div class="form-group col-12 col-md-4">
              <label for="dni" v-text="idioma.dni" class="requerido"></label><br>
              <input type="text" id="dni" name="dni" v-model="cliente.dni" ref="dni" maxlength="9"
                     @blur="validate('dni',[{'lon':9}])"
                     :class="[{'error': validado.dni === false, 'success': validado.dni}]"><br>
              <small :class="[{ 'errorMsg': validado.dni === false, 'valid': validado.dni !== false}]"
                     v-text="idioma.errores.dni">
              </small>
            </div>

            <div class="form-group col-12 col-md-4">
              <label for="birthday" v-text="idioma.fnac" class="requerido"></label><br>
              <input type="date" id="birthday" name="birthday" ref="birthday"
                     v-model="cliente.birthday"
                     pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}"
                     @blur="validate('birthday',[{'edad':18}])"
                     :max="adultAge"
                     :class="[{'error': validado.birthday === false, 'success': validado.birthday}]">
              <br>
              <small :class="[{ 'errorMsg': validado.birthday === false, 'valid': validado.birthday !== false}]"
                     v-text="idioma.errores.fnac"></small>
            </div>

            <div class="form-group col-12 col-md-4">
              <label for="direccion" v-text="idioma.direccion" class="requerido"></label><br>
              <input type="text" id="direccion" name="direccion" v-model="cliente.street" ref="street"
                     @blur="validate('street',[{'lon':3}])"
                     maxlength="150"
                     :class="[{'error': validado.street === false, 'success': validado.street}]">
              <br>
              <small :class="[{ 'errorMsg': validado.street === false, 'valid': validado.street !== false }]"
                     v-text="idioma.errores.direccion"></small>
            </div>
            <div class="form-group col-12 col-md-4">
              <label for="pais" v-text="idioma.pais" class="requerido"></label><br>
              <select id="pais" name="pais" v-model="cliente.country" ref="country" @change="checkCountry"
                      :class="[{'error': validado.country === false, 'success': validado.country}]">
                <option :key="idPais" v-for="(pais, idPais) in countriesList" :value="pais">{{ pais }}</option>
              </select><br>
              <small :class="[{ 'errorMsg': validado.country === false, 'valid': validado.country !== false}]"
                     v-text="idioma.errores.pais"></small>
            </div>

            <div class="form-group col-12 col-md-4">
              <label for="cp" v-text="idioma.cp" class="requerido"></label><br>
              <input type="text" id="cp" name="cp" v-model="cliente.postcode" ref="postcode"
                     @blur="validate('postcode',[{'lon': 5 }])"
                     maxlength="5"
                     :class="[{'error': validado.postcode === false, 'success': validado.postcode}]"><br>
              <small :class="[{ 'errorMsg': validado.postcode === false, 'valid': validado.postcode !== false}]"
                     v-text="idioma.errores.cp"></small>
            </div>

            <div class="form-group col-12 col-md-4">
              <label for="ciudad" v-text="idioma.poblacion" class="requerido"></label><br>
              <input type="text" id="ciudad" name="ciudad" v-model="cliente.city" ref="city"
                     @blur="validate('city',[{'lon':3}])"
                     maxlength="30"
                     :class="[{'error': validado.city === false, 'success': validado.city}]"><br>
              <small :class="[{ 'errorMsg': validado.city === false, 'valid': validado.city !== false}]"
                     v-text="idioma.errores.poblacion"></small>
            </div>

            <div class="form-group col-12 col-md-4" :class="{ 't-disabled': !mostrarProv }">
              <label for="provincia" v-text="idioma.provincia" class="requerido"></label><br>
              <select id="provincia" name="provincia" v-model="cliente.state" ref="state"
                      :class="[{'error': validado.state === false, 'success': validado.state}]">
                <option :key="idProvincia" v-for="(provincia, idProvincia) in provList" :value="provincia">{{
                    provincia
                  }}
                </option>
              </select>
              <!--          <input type="text" id="provincia" name="provincia" v-model="cliente.state" ref="state"
                               maxlength="25" :disabled="!mostrarProv"
                               @blur="validate('state',[{'lon':3}])"
                               :class="[{'error': validado.state === false, 'success': validado.state}]">--><br>
              <small :class="[{ 'errorMsg': validado.state === false, 'valid': validado.state !== false}]"
                     v-text="idioma.errores.provincia"></small>
            </div>


            <div class="form-group col-12 col-md-8 text-uppercase my-4" v-if="!autenticado && !registrado">
              <div class="checkbox nuevoUsuario py-0 my-0">
                <label
                  class="chkReservas d-flex flex-row justify-content-start align-items-center align-content-center">
                  <input type="checkbox" v-model="cliente.registrar"/>
                  <span class="cr bg-white"><i
                    class="cr-icon fa fa-check"></i></span>
                  ¿Quieres crear un usuario con estos datos?
                </label>
                <!--<div class="infoBtn infoBtnContinuo" data-toggle="modal" data-target="#infoTarjeta"><i
                  class="fa icon-info info"></i></div>-->
              </div>
            </div>

            <div class="form-group col-12">
              <label for="observaciones" v-text="idioma.observaciones"></label><br>
              <textarea name="observaciones" id="observaciones" v-model="cliente.observaciones"></textarea>
            </div>

            <div class="form-group col-12">
              <div class="alert-info infoPago">
                <p class="colorAquamarina font-weight-bold" v-text="idioma.seguro.titulo"></p>
                <p><span class="colorAquamarina font-weight-bold">{{ idioma.seguro.web }}</span> <span
                  :key="index" v-for="(txtSeguro, index) in idioma.seguro.texto">{{ txtSeguro }}</span></p>
              </div>
            </div>
          </div>
        </article>
        <!-- Protección de datos y publi. -->
        <article class="col-12">
          <div class="form-group col-12">
            <div class="checkbox">
              <label :class="['chkReservas', { 'labelError': validado.tarjetainfo === false}]">
                <input type="checkbox" v-model="cliente.tarjetainfo"/>
                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                {{ idioma.tarjetainfo }}
                <div class="infoBtn infoBtnContinuo" data-toggle="modal" data-target="#infoTarjeta"><i
                  class="fa icon-info info"></i></div>
              </label>
              <small :class="[{ 'errorMsg': validado.tarjetainfo === false, 'valid': validado.tarjetainfo !== false }]">
                Este campo es obligatorio
              </small>
            </div>
          </div>

          <div class="form-group col-12" v-if="!autenticado">
            <div class="checkbox">
              <label class="chkReservas">
                <input type="checkbox" id="informacion" v-model="cliente.informacion">
                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                {{ idioma.informacion }}</label>
            </div>
          </div>

          <div class="form-group col-12">
            <div class="checkbox">
              <label :class="['chkReservas', { 'labelError': validado.conformidad === false}]">
                <input type="checkbox" id="conformidad"
                       required v-model="cliente.conformidad">
                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                {{ idioma.conformidad.acepto }} <a href="https://alberguesyrefugios.com/condiciones"
                                                   class="enlace-condiciones"
                                                   target="_blank"
                                                   v-text="idioma.condiciones"></a>
              </label>
              <small :class="[{ 'errorMsg': validado.conformidad === false, 'valid': validado.conformidad !== false }]">
                Este campo es obligatorio
              </small>
            </div>
          </div>
          <div class="form-group col-12">
            <div class="checkbox">
              <label class="chkReservas">
                <input type="checkbox" id="proteccion"
                       required v-model="cliente.privacidad">
                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                {{ idioma.proteccion.acepto }} <a class="enlace-condiciones"
                                                  href="https://alberguesyrefugios.com/politica-privacidad"
                                                  target="_blank"
                                                  v-text="idioma.proteccion.datos"></a>
              </label>
            </div>
          </div>

          <div class="form-group col-12" v-if="covidRefuges()">
            <div class="checkbox">
              <label class="chkReservas">
                <input type="checkbox" id="informacion2" v-model="covid">
                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                {{ idioma.covid.pre }} <a class="enlace-condiciones" href="//www.alberguesyrefugios.com/covid19"
                                          target="_blank">{{ idioma.covid.anchor }}</a> {{ idioma.covid.post }}</label>
            </div>
          </div>
        </article>
        <!-- Botones de acción -->
        <br>
        <article class="col-12 ">
          <button type="reset" class="cancelar" data-toggle="modal" data-target="#cancelar">{{ idioma.CancelarBtn }}
          </button>
          <button @click="addCustomerData"
                  :disabled="!cliente.conformidad || !cliente.tarjetainfo || !cliente.privacidad || !covid"
                  class="continuar"
                  :class=" [{'disabled': !cliente.conformidad || !cliente.tarjetainfo || !cliente.privacidad || !covid}]">
            {{ idioma.btnPagar }}
          </button>
        </article>
      </div>
    </div>


    <ModalsController :idioma="idioma" modal="infoTarjeta"/>
    <ModalsController :idioma="idioma" modal="infoAdelanto"/>
    <ModalsController :idioma="idioma" @cancelar="cancelar" modal="cancelar"/>
    <ModalsController
      :idioma="{ tituloExiste: idioma.tituloExiste, existe: idioma.existe, olvido: idioma.login.modal.olvido }"
      modal="registrado"/>
  </section>
</template>

<script>
import { customerHelper, countries, datesHelper, refugesHelper, prefixes, provinces } from '../../_helpers'
import { refugeService, customerService } from '../../_services'
import { mapGetters } from 'vuex'
import CustomerLogin from '../login/CustomerLogin'
import ModalsController from './../modals/ModalsController'
import { errorOptions } from '../../_config'

export default {
  name: 'UserIdentify',
  props: ['idioma', 'userId'],
  data () {
    return {
      ok: false,
      status: false,
      autenticado: false,
      registrado: false,
      personales: false,
      covid: true,
      mostrarProv: false,
      cliente: {
        name: '',
        surname: '',
        dni: '',
        birthday: '',
        street: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
        email: '',
        confirmar: '',
        phone: '',
        registrar: false,
        observaciones: '',
        tarjetainfo: false,
        informacion: false,
        conformidad: false,
        privacidad: false
      },
      validado: {
        name: null,
        surname: null,
        dni: null,
        birthday: null,
        street: null,
        postcode: null,
        city: null,
        state: null,
        country: null,
        email: null,
        confirmar: null,
        phone: null,
        registrar: true,
        observaciones: true,
        tarjetainfo: null,
        conformidad: null,
        privacidad: true
      },
    }
  },
  created () {
    if (this.getToken() !== '') {
      this.loadCustomer()
      this.autenticado = true
    }
  },
  methods: {
    ...mapGetters(['getBooking', 'getCustomer', 'getToken']),
    validate (m, validators) {
      if (m === 'email') {
        customerService.checkUserExists(this.cliente[m]).then(data => {
          if (parseInt(data.existe) > 0) {
            this.registrado = true
            $('#registrado').modal()
          }
        })
      }

      const res = customerHelper.validateField(this.cliente[m], validators)
      this.validado[m] = !!res.result
      if (!res.result) this.$refs[m].focus()
    },
    checkCountry () {
      if (this.cliente.country === 'España') {
        this.mostrarProv = true
        this.cliente.state = ''
      } else {
        this.cliente.state = 'extranjero'
        this.mostrarProv = false
      }
    },
    validateForm () {
      let _ok = true
      if (this.cliente.name.length < 3) {
        this.validado.name = false
        _ok = false
      } else this.validado.name = true

      if (this.cliente.surname.length < 3) {
        this.validado.surname = false
        _ok = false
      } else this.validado.surname = true
      // Si es español valida el dni, en caso de ser extrangero campo de entrada libre

      if (this.$store.getters.currentLanguage === 'es' || this.$store.getters.currentLanguage === 'ca') {
        if (!customerHelper._validateDniNie(this.cliente.dni)) {
          this.validado.dni = false
          _ok = false
        } else this.validado.dni = true
      } else if (this.cliente.dni.length === 0) {
        this.validado.dni = false
        _ok = false
      } else this.validado.dni = true

      if (!datesHelper.isAdult(this.cliente.birthday) || this.cliente.birthday === '') {
        this.validado.birthday = false
        _ok = false
      } else this.validado.birthday = true

      if (this.cliente.street.length < 3) {
        this.validado.street = false
        _ok = false
      } else this.validado.street = true

      if (this.cliente.postcode.length < 4) {
        this.validado.postcode = false
        _ok = false
      } else this.validado.postcode = true

      if (this.cliente.city.length < 3) {
        this.validado.city = false
        _ok = false
      } else this.validado.city = true

      if (this.cliente.state.length < 3) {
        this.validado.state = false
        _ok = false
      } else this.validado.state = true

      if (this.cliente.country.length === 0) {
        this.validado.country = false
        _ok = false
      } else this.validado.country = true

      if (this.cliente.phone.length < 9) {
        this.validado.phone = false
        _ok = false
      } else this.validado.phone = true

      if (this.cliente.email.length < 3 || !customerHelper._validateEmail(this.cliente.email)) {
        this.validado.email = false
        _ok = false
      } else this.validado.email = true

      if (this.cliente.confirmar.length < 3 || this.cliente.confirmar !== this.cliente.email) {
        this.validado.confirmar = false
        _ok = false
      } else this.validado.confirmar = true

      if (!this.cliente.tarjetainfo) {
        this.validado.tarjetainfo = false
        _ok = false
      } else this.validado.tarjetainfo = true

      if (!this.cliente.conformidad) {
        this.validado.conformidad = false
        _ok = false
      } else this.validado.conformidad = true

      if (_ok) {
        this.personales = false
        this.verResumen = true
      }
    },
    confirmEmail () {

      if (this.cliente.email !== this.cliente.confirmar)
        this.validado.confirmar = false
      else
        this.validado.confirmar = true
    },
    checkCondiciones () {
      if (this.cliente.conformidad)
        this.validado.conformidad = true
      else
        this.validado.conformidad = false

      if (this.cliente.tarjetainfo)
        this.validado.tarjetainfo = true
      else
        this.validado.tarjetainfo = false
    },
    addCustomerData () {
      let rdo = true
      this.validateForm()
      for (let _val in this.validado) {
        if (!this.validado[_val] || this.validado[_val] === null) {
          rdo = false
          break
        }
      }
      if (rdo) {
        this.cliente['id'] = this.getBooking().items[0].booking
        const prefix = prefixes[this.cliente.country]
        if (this.cliente.phone.charAt(0) !== '+')
          this.cliente.phone = (typeof prefix !== 'undefined') ? `+${prefix} ${this.cliente.phone}` : this.cliente.phone
        const _data = refugesHelper.prepareToSend(this.cliente, 'bookingData')

        refugeService.postCustomerData(_data).then(data => {
          if (data.response === true) {
            // Confirmación
            this.$emit('toSummary')
          } else {
            this.$emit('errorHandler', { typeError: 'error', errorMessage: data.message })
          }
        })
      }
    },
    loadCustomer () {
      Object.assign(this.cliente, this.getCustomer())

      for (const key of Object.keys(this.validado)) {
        this.validado[key] = true
      }

      this.mostrarProv = true
    },
    logueado () {
      this.loadCustomer()
      this.autenticado = true
      this.$emit('errorHandler', { typeError: 'success', errorMessage: 'Bienvenid@' })

      //this.addCustomerData()

    },
    salir () {
      this.autenticado = false
      this.cancelar()
    },
    cancelar () {
      this.$emit('cancelBooking')
    },
    covidRefuges () {
      return false
      /*
      let cov19 = false
      const total = this.getBooking().items.filter( r => parseInt(r.covidAlert) === 1)
      if(total.length > 0 ) {
        cov19 = true
      }else {
        this.covid = true
      }
      return cov19
      */

    }
  },
  computed: {
    countriesList () {
      return countries
    },
    provList () {
      return provinces
    },
    adultAge: function () {
      return datesHelper.adultDate().format('YYYY-MM-DD')
    }
  },
  components: {
    CustomerLogin,
    ModalsController
  }
}
</script>
<style>
.not-user {
  border-radius: 1rem;
  border-color: #05bdbd;
  background: linear-gradient(0deg, rgba(5, 189, 189, 0.1) 0%, rgba(5, 189, 189, 0.5) 100%);
}
#myTab .active {
  background-color: transparent!important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/UserIdentify.vue